import { Col, SelectField } from '@/components';
import type { ProjectSearchFormType } from '@/features/search/_models/projects-search';
import type { SharedSearchFormType } from '@/features/search/_models/shared-search';
import { COL_MIN_WIDTH } from '@/features/search/_utils/projects-search';
import {
  ImplementationMethodLabelModifier,
  implementationMethodEnum,
} from '@/utils/enum';
import { type FC, memo } from 'react';
import { useFormContext, useWatch } from 'react-hook-form';
import { useTranslation } from 'react-i18next';

const options = implementationMethodEnum.options.map((value) => ({
  value,
  label: ImplementationMethodLabelModifier[value],
}));

export const ImplementationMethodsColField: FC = memo(() => {
  const { t } = useTranslation();
  const {
    control: sharedSearchControl,
    formState: { errors },
  } = useFormContext<SharedSearchFormType>();

  const sheetType = useWatch({
    control: sharedSearchControl,
    name: 'sheetType',
  });

  const { control: projectSearchControl } =
    useFormContext<ProjectSearchFormType>();

  const skipAdministrativeReformTeamEvaluation = useWatch({
    control: projectSearchControl,
    name: 'skipAdministrativeReformTeamEvaluation',
  });

  if (sheetType !== 'RS' || skipAdministrativeReformTeamEvaluation === 'true') {
    return null;
  }

  return (
    <Col span={4} style={{ minWidth: COL_MIN_WIDTH.basic }}>
      <SelectField
        name="implementationMethods"
        label={t('implementation-method')}
        control={sharedSearchControl}
        errors={errors}
        options={options}
        mode="multiple"
      />
    </Col>
  );
});
